const Contact = () => {

  return (
    <section id="contato" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          {/* Left: Info */}
          <div>
            <span className="text-[#C4A45A] text-xs tracking-[0.35em] uppercase font-raleway block mb-4">
              Fale Conosco
            </span>
            <h2 className="font-cormorant text-4xl md:text-5xl text-[#2C2B29] font-light mb-6">
              Agende sua<br /><em>Avaliação Gratuita</em>
            </h2>
            <p className="font-raleway text-[#8B8680] text-sm leading-relaxed mb-8 max-w-sm">
              Dê o primeiro passo para uma versão mais confiante de você. Preencha o formulário ou nos chame no WhatsApp — respondemos rapidamente!
            </p>

            <div className="flex flex-col gap-5">
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#FAF7F2] text-[#C4A45A] flex-shrink-0">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <div>
                  <p className="font-raleway text-xs text-[#8B8680] uppercase tracking-widest">Endereço</p>
                  <p className="font-raleway text-sm text-[#2C2B29]">Rua Primeiro de Maio, 202, Sala 601 – Centro, Santo André – SP</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#FAF7F2] text-[#C4A45A] flex-shrink-0">
                  <i className="ri-whatsapp-line text-lg"></i>
                </div>
                <div>
                  <p className="font-raleway text-xs text-[#8B8680] uppercase tracking-widest">WhatsApp</p>
                  <a
                    href="https://wa.me/551122289498"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="font-raleway text-sm text-[#2C2B29] hover:text-[#C4A45A] transition-colors cursor-pointer"
                  >
                    (11) 2228-9498
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#FAF7F2] text-[#C4A45A] flex-shrink-0">
                  <i className="ri-instagram-line text-lg"></i>
                </div>
                <div>
                  <p className="font-raleway text-xs text-[#8B8680] uppercase tracking-widest">Instagram</p>
                  <a
                    href="https://www.instagram.com/mgsaudeeestetica"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="font-raleway text-sm text-[#2C2B29] hover:text-[#C4A45A] transition-colors cursor-pointer"
                  >
                    @mgsaudeeestetica
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#FAF7F2] text-[#C4A45A] flex-shrink-0">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <p className="font-raleway text-xs text-[#8B8680] uppercase tracking-widest">Horários</p>
                  <p className="font-raleway text-sm text-[#2C2B29]">Seg–Sex: 09h–18h &nbsp;|&nbsp; Sáb: 09h–13h</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="w-full h-full min-h-[520px] rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/21e19603d42babf1dc4380dbdbe591fa/64f8df371732c6ad8175360f50772010.png"
              alt="Cadeira odontológica moderna na clínica MG+ Saúde & Estética"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
